export default __webpack_public_path__ + "static/media/gm-sb-girl.e2fcf73d.webp";